import baseClasses from '@components/Themes/layout.module.scss'
import React, { FunctionComponent } from 'react'

const UserHandling: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses

  return (
    <React.Fragment>
      <div className={classes.mainPanel}></div>
    </React.Fragment>
  )
}

export default UserHandling
